import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const CompanyInfo = () => { 
  const companies = useSelector(state => state.company.companies);
  const main = useSelector(state => state.main);
  const companySelected = main.companySelected;

  const infoCompany = companies.find(el => el.id === companySelected);

  return (
    <div>
      <div data-testid="sentenceCreateDeadlineForCompany">
        <FormattedMessage id="deadlines.pages.create.companyList1" />
        <b>{infoCompany.ragioneSociale}</b>.
        <FormattedMessage id="deadlines.pages.create.companyList2" />
      </div>
    </div>
  );
};

export default CompanyInfo;
